import { APPLICATION_FORM_ID } from '../constants';

export const BLOCKING_FIELDS_MESSAGE =
  'Some fields still need attention. Please review the highlighted fields.';

// Runs the full validation pass once every field is on screen, so each field
// that still blocks completion shows its error, then brings the first one into
// view. Save & Close deliberately skips validation, which is how a
// half-finished application gets stored in the first place.
export default async function revealBlockingFields({ trigger, onInvalid }) {
  const isValid = await trigger();

  if (isValid) return true;

  onInvalid();

  // The error toast takes focus as it mounts, and the form scrolls inside its
  // own box rather than the window, so the first invalid input is scrolled
  // and focused explicitly once the toast is in place.
  window.setTimeout(() => {
    const firstInvalidInput = document
      .getElementById(APPLICATION_FORM_ID)
      ?.querySelector('[aria-invalid="true"]');

    if (!firstInvalidInput) return;

    firstInvalidInput.scrollIntoView({ block: 'center' });
    firstInvalidInput.focus({ preventScroll: true });
  }, 0);

  return false;
}
